import React from "react";
import { Link } from "react-router-dom";
import projectLogo from "../assets/Logo.jpg";

function ThankYou() {
  return (
    <main className="min-h-screen bg-[#f4f6fb] px-4 py-10">
      <div className="mx-auto max-w-xl rounded-xl bg-white p-8 text-center shadow-sm">
        <img
          src={projectLogo}
          alt="Lodha Sovrano"
          className="mx-auto mb-5 h-[56px] w-auto object-contain"
        />
        <h1 className="text-3xl font-bold text-[#445579]">Thank You</h1>
        <p className="mt-4 text-base text-slate-700">
          Your enquiry has been submitted successfully. Our team will contact you soon.
        </p>
        <Link
          to="/"
          className="mt-6 inline-block rounded-md bg-[#5d627d] px-5 py-2 text-base font-semibold text-white hover:bg-[#4f5368]"
        >
          Back To Home
        </Link>
      </div>
    </main>
  );
}

export default ThankYou;
